import Button from "../Button";
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import IndividualScheduleForm from "./IndividualScheduleForm";
import { post } from "../../lib/Fetching";
import _ from "underscore";
import { format } from "path";

export default class ProductSchedulesForm extends React.Component {
  state = {
    newScheduleIds: []
  };

  constructor(props) {
    super(props);
    this._nodes = new Map();
  }

  componentDidMount() {
    this.addNewScheduleForm();
  }

  addNewScheduleForm = () => {
    this.setState(state => ({
      newScheduleIds: state.newScheduleIds.concat(Math.random())
    }));
  };

  removeScheduleForm = formId => {
    const { toggleScheduleForm } = this.props;
    this.setState(
      state => ({
        newScheduleIds: state.newScheduleIds.filter(id => id !== formId)
      }),
      () => {
        this._nodes.delete(formId);
        if (this.state.newScheduleIds.length == 0) {
          toggleScheduleForm();
        }
      }
    );
  };

  saveSchedules = () => {
    const validation = this.validate();
    if (!validation.valid) {
      alert(validation.errors.join(". "));
      return;
    }
    const { product, toggleScheduleForm, reloadProduct } = this.props;
    post("/products/product_test_schedules/", {
      product_id: product.id,
      schedules: this.individualForms().map(f => f.scheduleParameters())
    })
      .then(json => {
        if (json.errors) {
          alert("Problem: " + json.errors);
          return;
        }
        toggleScheduleForm();
        reloadProduct();
      })
      .catch(error => {
        alert(error);
      });
  };

  individualForms = () => {
    return Array.from(this._nodes.values());
  };

  // removeDuplicates = array => {
  //   return _.uniq(array, false, (a,b) => _.isEqual(a,b));
  // };

  validate = () => {
    const forms = this.individualForms();
    const errors = [];
    var formsWithErrorsCount = forms.filter(f => !f.isValid()).length;

    // var duplicatedScheduleCount =
    //   forms.length - this.removeDuplicates(forms.map(f => f.scheduleParameters())).length;
    // if (duplicatedScheduleCount > 0)
    //   errors.push(`${duplicatedScheduleCount} schedules are duplicated`);
    if (formsWithErrorsCount > 0) errors.push(`${formsWithErrorsCount} schedules have errors`);
    return { valid: errors.length == 0, errors };
  };

  render() {
    const { company_id, toggleScheduleForm } = this.props;
    const { newScheduleIds } = this.state;
    return (
      <div style={{ padding: 10 }}>
        {newScheduleIds.map(id => (
          <IndividualScheduleForm
            ref={ref => this._nodes.set(id, ref)}
            key={id}
            id={id}
            company_id={company_id}
            removeForm={() => this.removeScheduleForm(id)}
            hideDelete
          />
        ))}
        <div style={{ padding: 10, textAlign: "center" }}>
          <Button
            onClick={this.saveSchedules}
            icon="fa-save"
            title={newScheduleIds.length == 1 ? "Save Schedule" : "Save Schedules"}
            primary
          />
          &nbsp;&nbsp;
          <Button onClick={toggleScheduleForm} title="Cancel" />
        </div>
      </div>
    );
  }
}

ProductSchedulesForm.propTypes = {
  company_id: PropTypes.number,
  toggleScheduleForm: PropTypes.func,
  product: PropTypes.object,
  reloadProduct: PropTypes.func
};
